import React, {useEffect} from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next'
import cookie from "js-cookie";
import { isProvider } from "../../features/user";
import { delay, getLang } from '../../Helper';
import Menu from './Menu';
import ProviderMenu from './ProviderMenu';
import { Capacitor } from '@capacitor/core';


const Header = ({headerWhite, showMenu, showBack=true, backOveride}) => {

    const { i18n } = useTranslation()
    const navigate = useNavigate();
    const location = useLocation();
    const isUserProvider = useSelector(isProvider);
    //console.log(navigate);

    const goBack = () => {
        if (canShowBack()) {
            if(backOveride) {
                backOveride();
            } else {
                navigate(-1);
            }
        }
    };

    useEffect(()=>{
        let lang = getLang();
        if(!lang) {
            const userLang = navigator.language || navigator.userLanguage;
            lang = userLang==='en-US'?'en':'he';
            lang = 'he';
        }
        requestChangeLanguage(lang);
        // eslint-disable-next-line
    },[]);

    const requestChangeLanguage = async (lang) => {
        await delay(1);
        changeLanguage(lang);
    }


    const changeLanguage = (lang) => {
        //console.log(lang);
        cookie.set('lang', lang, { sameSite: 'strict', expires: 365 });
        i18n.changeLanguage(lang);
        document.dir = lang==='en'?'ltr':'rtl';
    }

    const iOS = () => {
        return Capacitor.getPlatform() === 'ios' && Capacitor.isNativePlatform();
       /* return [
          'iPad Simulator',
          'iPhone Simulator',
          'iPod Simulator',
          'iPad',
          'iPhone',
          'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)*/
      }


    const canShowBack = () => {
        return showBack &&!['/', '/start', '/home', '/writer-profile'].includes(location.pathname);
    }

    // return <div className={`header ltr ${headerWhite ? 'background-white' : ''}`}>
    return <div className={`header ltr pointer-events-none ${iOS()?'iOS mt10':''}`}>
        {canShowBack()?<img src={'/images/back_arrow.png'} onClick={() => goBack('en')} className='ml5 mr5 back-icon pointer-events-initial' alt=''/>:<div> </div>}
        {/* <img src='/images/header-logo.png' className='header-logo' alt=''/> */}
        <div className='header-icons ltr pointer-events-initial'>
            <img src={'/images/flags/flag-usa.png'} onClick={() => changeLanguage('en')} className='ml5 mr5 flag-icon' alt=''/>
            <img src={'/images/flags/flag-israel.png'} onClick={() => changeLanguage('he')} className='ml5 mr5 flag-icon' alt=''/>
            {/* <img src='/images/notification-icon.png' className='notification-icon mr15' alt=''/> */}
            {/* <img src='/images/user-icon.png' className='user-icon' alt=''/> */}
        </div>
        {headerWhite?<div className='center-div-absolute pointer-events-none'><img src={'/images/list_logo.png'} className='header-logo' alt=''/></div>:null}
        {showMenu?(isUserProvider?<ProviderMenu></ProviderMenu>:<Menu></Menu>):null}
    </div>;
};


export default Header;